/* React */
import React from "react";

/* React Redux */
import { useDispatch } from "react-redux";
import { setScrollPosition } from "src/redux/features/scrolling/scrollSlice";

/* Ionic */
import { IonContent } from "@ionic/react";

/* Components */
import Header from "src/components/imprint/header/Header";
import Footer from "src/components/shared/footer/Footer";

/* Stylesheet */
import styles from "./ContentPageWrapper.module.scss";

/* Interfaces */
interface ContentPageWrapperProps {
  children: React.ReactNode;
}

const ContentPageWrapper: React.FC<
  ContentPageWrapperProps
> = ({ children }) => {
  const dispatch = useDispatch();

  const handleScroll = (event: CustomEvent) => {
    const scrollTop = event.detail.scrollTop;
    dispatch(setScrollPosition(scrollTop));
  };

  return (
    <IonContent
      className={styles.content_page_wrapper}
      scrollEvents={true}
      onIonScroll={handleScroll}
    >
      <Header />
      <div className={styles.wrapper_container}>
        {children}
      </div>
      <Footer />
    </IonContent>
  );
};

export default ContentPageWrapper;
